import React from 'react';

import './hero-image.css';

const HeroImage = ({ img, title }) => {
  const style = img ?
    { backgroundImage: `url(${img})`} :
    { backgroundColor: 'transparent' };

  return (
    <div className="static-image" style={style}>
      {(!!title) && (
        <h1 className="header-title">
          {title}
        </h1>
      )}
    </div>
  );
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/widgets/HeroImage/index.jsx